module.exports = __webpack_public_path__ + "img/framenew_box26.63482f63.jpg";